module.exports = __webpack_public_path__ + "static/media/pred-corona.72472e18.jpg";